import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { trackEvent } from "@/lib/analytics";

export function MobileBookingBar() {
  const { pathname } = useLocation();
  const { settings } = useSettings();
  if (pathname.startsWith("/prenota") || pathname.startsWith("/admin")) return null;
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 flex border-t border-wood/20 bg-cream/95 backdrop-blur-md"
      data-testid="mobile-booking-bar"
    >
      <a
        href={`tel:${settings.phone_link || "+393311091971"}`}
        data-testid="mobile-bar-call"
        onClick={() => trackEvent("click_phone", { position: "barra_mobile" })}
        className="flex items-center justify-center gap-2 w-2/5 py-4 text-[0.68rem] uppercase tracking-[0.2em] text-wood"
      >
        <Phone size={14} strokeWidth={1.5} /> Chiama
      </a>
      <Link
        to="/prenota"
        data-testid="mobile-bar-book"
        onClick={() => trackEvent("click_booking", { position: "barra_mobile" })}
        className="flex-1 flex items-center justify-center bg-sage text-cream py-4 text-[0.68rem] uppercase tracking-[0.2em]"
      >
        Prenota un tavolo
      </Link>
    </div>
  );
}

export default MobileBookingBar;
